export default __webpack_public_path__ + "static/bakstol-example2-ba88a8d0c85b7867cf3b86aa60a9b699.png";